var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M19.118 8.26c-2.52 0-4.21 1.383-4.902 2.694h-.07V8.676h-4.97v16.67h5.178V17.1c0-2.174.413-4.28 3.11-4.28 2.656 0 2.69 2.486 2.69 4.42v8.107h5.18v-9.144c0-4.49-.97-7.942-6.216-7.942zM.746 8.676h5.18v16.67H.747z","key":0}),React.createElement("circle",{"cx":"3.337","cy":"3.393","r":"3.004","key":1})]));
}

LinkedinIcon.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
